// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__12nGn"};